import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'mnf-project-info-updates',
  templateUrl: './project-info-updates.component.html',
  styleUrls: ['./project-info-updates.component.scss']
})
export class ProjectInfoUpdatesComponent {
  
  @Input() selectedIndex: number;
  @Input() dev: any;
  @Input() userParts: any;
  
  devInfoDetail: { linkUpdates: string, access: string, updates: string; };
  updates: any;

  width: number = window.innerWidth || 250;
  height: number = 900;

  constructor(private toastr: ToastrService, private dom: DomSanitizer) { }

  ngOnInit(): void {
    this.devInfoDetail = this.dev?.devInfoDetail;
    this.updates = this.devInfoDetail?.updates ? this.dom.bypassSecurityTrustResourceUrl(this.devInfoDetail?.updates) : null;
  }

  /** Verificar si el usuario tiene participaciones en el proyecto */
  searchByPID(pid: string) {
    return this?.userParts?.some(item => item?.pid === pid);
  }

  /** Función para copíar la contraseña de acceso */
  copyPass() {
    if (this.devInfoDetail?.access) {
       navigator.clipboard.writeText(this.devInfoDetail?.access).then(() => {
          this.toastr.info('Se ha copiado correctamente la contraseña de acceso');
       }).catch(() => this.toastr.info('No se pudo copiar la contraseña de acceso, intentelo nuevamente'));
    } else {
       this.toastr.info('Se ha copiado correctamente la contraseña de acceso');
    }
  }
  
  /** Función para abrir enlace */
  openLink(link: string): void {
    window.open(link, '_blank');
  }

  ngAfterViewInit(): void {
    if(this.width > 992) {
       this.width = window.innerWidth - 250;
    }
 }

}
